import React from 'react'
import {CTA, Text} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import {Trans, useTranslation} from 'react-i18next'
import {JobAdvertisement} from '../types/jobAdvertisement'
import {State} from '../types/state'

const Root = styled.div`
    align-items: center;
    display: flex;
    gap: ${(props) => props.theme.size.static300};
    margin-bottom: ${(props) => props.theme.size.static510};
    margin-top: ${(props) => props.theme.size.static370};
`

interface StatusProps {
    jobAdvertisementsDisplaying: JobAdvertisement[]
    removeFilters: () => void
    state: State
}

export const Status: React.FunctionComponent<StatusProps> = (props) => {
    const {jobAdvertisementsDisplaying, removeFilters, state} = props
    const {t} = useTranslation('fa-posizioni-aperte')

    return (
        <Root>
            <Text>
                <Trans>
                    {t('jobAdvertisementsList.displaying', {
                        jobAdvertisementsDisplaying:
                            jobAdvertisementsDisplaying.length,
                        jobAdvertisementsCount: state.jobAdvertisements.length,
                    })}
                </Trans>
            </Text>

            {(state.selectedCategories.length > 0 ||
                state.selectedProvinces.length > 0) && (
                <CTA
                    aria-label={t('jobAdvertisementsList.removeFilters')}
                    emphasis="tertiary"
                    onClick={(e) => {
                        e.preventDefault()

                        removeFilters()
                    }}
                    tag="button"
                >
                    {t('jobAdvertisementsList.removeFilters')}
                </CTA>
            )}
        </Root>
    )
}
